'use client'
import { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Image from "next/image";
import { Advertisement, ensureAbsoluteUrl } from "../utils/interfaces";

const AdvertisementImage = ({ code, width, height }: { code: string, width: number, height: number }) => {

  const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;
  const [ad, setAd] = useState<Advertisement | null>(null);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}advertisement/${code}/`);
        if (!response.ok) throw new Error('Failed to fetch article data');
        const data = await response.json();
        setAd(data);
      } catch (err: any) {
      }
    };
    fetchData();
  }, [API_BASE_URL, setAd]);

  return (
    <>
      {ad != null ? (
        ad.url ? (
          <a className="hover:brightness-90 transition-all" href={ensureAbsoluteUrl(ad.url)}>
            <Image
              src={ad.image}
              alt={code}
              width={900}
              height={300}
              className=""
            />
          </a>
        ) : (
          <Image
            src={ad.image}
            alt={code}
            width={900}
            height={300}
            className=""
          />
        )
      ) : (
        <></>
      )}
    </>
  );
};

export default AdvertisementImage;